import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  DeclaracionAdheridoControllerService,
  DeclaracionAdheridoCreatePayloadDTO,
  DeclaracionAdheridoDTO,
  DeclaracionCentroDTO,
  DeclaracionCentroFilterDTO,
  DeclaracionCentroControllerService,
  DeclaracionEnvaseControllerService,
  DeclaracionEnvaseFilterDTO,
  PageDTODeclaracionEnvaseDTO
} from 'api-rest';
import moment, { now } from 'moment';
import { SpinnerService } from '../../../services/spinner.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { ValidateService } from '../../../services/validate.service';
import swal from 'sweetalert2';
import { Router } from '@angular/router';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import {ParseCurrencyPipe} from '../../../share/components/pipe/ParseCurrency.pipe';

@Component({
  selector: 'lib-package-general-data',
  templateUrl: './package-general-data.component.html',
  styleUrls: ['./package-general-data.component.scss'],
})
export class PackageGeneralDataComponent implements OnChanges, OnInit {
  formGroup!: FormGroup;
  @Input() declaracionAdherido!: DeclaracionAdheridoDTO | any;
  @Input() centrosDeclaracion!: DeclaracionCentroDTO[];
  @Input() centrosEnvases:any[] = [];
  @Input() searchFormState: any;
  @Output() actualizarDeclaracion: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  sumatoriaCurso: number = 0;
  sumatoriaAnterior: number = 0;
  sumatoriaDepCurso: number = 0;
  sumatoriaDepAnterior: number = 0;

  anoDatosCurso: any;
  anoDatosAnterior: any;

  declaracionDuplicada : any

  messagesForBanner : any = {
    2025: "Cuando la contribución anual total de todos los tipos de categorías de envases declarados, incluyendo todos los conceptos, sea inferior a 600 €, se facturará la contribución mínima anual de 600 €/año aprobada por la Asamblea General de ENVALORA.",
    2026: "Cuando la contribución anual total de todos los tipos de categorías de envases declarados, incluyendo todos los conceptos, sea inferior a 250€, se facturará la contribución mínima anual de 250€/año aprobada por la Asamblea General de ENVALORA.",
  }
  defaultSort: string = '';
  currentSort: string = '';
  pageNumber: number = 0;
  pageSize: number = 25;

  declaracionEnvase: any;
  avisoBidones : Boolean = true;

  mostrarBotonFinalizar : Boolean =  true;
  toolTipBotonFinalizar: String = 'No se puede finalizar la declaración con centros SDDR sin declaración de envase'
  EPSILON = 0.0001
  noEnvasesCategoriasNoSDDR = false;

  constructor(
    private formBuilder: FormBuilder,
    private declaracionAdheridoControllerSrv: DeclaracionAdheridoControllerService,
    private declaracionCentroControllerSrv: DeclaracionCentroControllerService,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private validateSrv: ValidateService,
    private router: Router,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService,
    private declaracionEnvaseControllerService : DeclaracionEnvaseControllerService,
    private parseCurrencyPipe: ParseCurrencyPipe,
  ) {
    this.formGroup = this.formBuilder.group({
      /*iban: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.pattern(this.validateSrv.ibanpattern),
          ]),
        },
      ],*/
      numPedido: [{ value: null, disabled: false }, Validators.maxLength(255)],
      fechaInicio: [{ value: null, disabled: true }],
      fechaFin: [{ value: null, disabled: true }],
      fechaRechazo: [{ value: null, disabled: true }],
    });
  }
  ngOnInit(): void {
    console.log('[PackageGeneralData ngOnInit] searchFormState recibido:', this.searchFormState);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['searchFormState']) {
      console.log('[PackageGeneralData ngOnChanges] searchFormState changed:', changes['searchFormState'].currentValue);
    }
    if (this.declaracionAdherido) {
      this.anoDatosCurso =
        (Number(this.declaracionAdherido?.anioDatos) || 0) + 1;
      this.anoDatosAnterior = this.declaracionAdherido?.anioDatos;

      if (!this.canAccessEditAllGlobal()) {
        /*this.formGroup.get('iban')?.disable();*/
        this.formGroup.get('numPedido')?.disable();
      }

      /*this.formGroup
        .get('iban')
        ?.setValue(this.declaracionAdherido?.ibanAdherido);*/
      this.formGroup
        .get('numPedido')
        ?.setValue(this.declaracionAdherido?.numeroPedido);
      let fInicio = '';
      if (this.declaracionAdherido?.fechaInicioDec) {
        fInicio = moment(
          new Date(this.declaracionAdherido?.fechaInicioDec)
        ).format('DD/MM/YYYY');
      }
      this.formGroup.get('fechaInicio')?.setValue(fInicio);
      let fFin = '';
      if (this.declaracionAdherido?.fechaFinalizacionDec) {
        fFin = moment(
          new Date(this.declaracionAdherido?.fechaFinalizacionDec)
        ).format('DD/MM/YYYY');
      }
      this.formGroup.get('fechaFin')?.setValue(fFin);
      let fRechazo = '';
      if (this.declaracionAdherido?.fechaRechazoDec) {
        fRechazo = moment(
          new Date(this.declaracionAdherido?.fechaRechazoDec)
        ).format('DD/MM/YYYY');
      }
      this.formGroup.get('fechaRechazo')?.setValue(fRechazo);
    }

    this.calcularSumatorias();

     if (changes['centrosDeclaracion'] || changes['centrosEnvases']) {
      this.buscarDeclaracionesEnvase();
    }
  }

  calcularSumatorias(): void {
    const getValue = (value: any): number => {
      return value != null && !isNaN(value) ? value : 0;
    };

    this.sumatoriaCurso =
      getValue(this.declaracionAdherido?.contriRapAnioCursoSoloUso) +
      getValue(this.declaracionAdherido?.contriRapAnioCursoAbierto) +
      getValue(this.declaracionAdherido?.contriRapAnioCursoCerrado);

    this.sumatoriaAnterior =
      getValue(this.declaracionAdherido?.contriRapAnioAnteriorSoloUso) +
      getValue(this.declaracionAdherido?.contriRapAnioAnteriorAbierto) +
      getValue(this.declaracionAdherido?.contriRapAnioAnteriorCerrado);

    this.sumatoriaDepCurso =
      getValue(this.declaracionAdherido?.depoRapAnioCursoAbierto) +
      getValue(this.declaracionAdherido?.depoRapAnioCursoCerrado);

    this.sumatoriaDepAnterior =
      getValue(this.declaracionAdherido?.depoRapAnioAnteriorAbierto) +
      getValue(this.declaracionAdherido?.depoRapAnioAnteriorCerrado);
  }
  guardar(): void {
      this.formGroup.enable()
    if (this.formGroup.valid) {
      this.formGroup.disable()
      let filtro: DeclaracionAdheridoCreatePayloadDTO = {
        adherido: this.declaracionAdherido?.adherido,
        anioDatos: this.declaracionAdherido?.anioDatos,
        version: this.declaracionAdherido?.version,
        fechaInicioDec: this.declaracionAdherido?.fechaInicioDec,
        estadoDeclaracion: this.declaracionAdherido?.estadoDeclaracion,
        estimacion: this.declaracionAdherido?.estimacion,
        /*ibanAdherido: this.formGroup.get('iban')?.value,*/
        numeroPedido: this.formGroup.get('numPedido')?.value,
      };
      this.spinnerSrv.loadingShow();
      this.declaracionAdheridoControllerSrv
        .editById5(this.declaracionAdherido?.id!, filtro)
        .subscribe({
          next: (responses) => {
            this.snackBarSrv.showSnackBar(
              'Se han guardado los datos generales correctamente',
              'success'
            );
            this.actualizarDeclaracion.emit(true);
            this.spinnerSrv.loadingHide();
          },
          error: () => {
            this.spinnerSrv.loadingHide();
          },
        });
    } else {
      this.formGroup.disable()
      this.snackBarSrv.showSnackBar(
        'Revisa los errores en los campos ',
        'error'
      );
    }
  }

  convertToComma(value: any): string {
    if (typeof value === 'number') {
      let stringValue = value.toFixed(5).replace('.', ',');
      stringValue = stringValue.replace(/,?0+$/, '');
      return stringValue;
    } else if (typeof value === 'string') {
      return value.replace('.', ',').replace(/,?0+$/, '');
    } else {
      return '0';
    }
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  buttonCancelar() {
    console.log('[PackageGeneralData buttonCancelar] searchFormState a guardar:', this.searchFormState);
    swal
      .fire({
        text: '¿Desea volver al buscador?',
        icon: 'question',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Sí',
        denyButtonText: 'No',
        allowOutsideClick: false,
      })
      .then((result: any) => {
        if (result.isConfirmed) {
          // Guardar formulario en sessionStorage antes de navegar
          console.log('[PackageGeneralData buttonCancelar] Guardando searchFormState:', this.searchFormState);
          sessionStorage.setItem('packageDeclarationSearchForm', JSON.stringify(this.searchFormState));
          console.log('[PackageGeneralData buttonCancelar] Formulario guardado en sessionStorage:', this.searchFormState);
          this.router.navigate(['/attached-app/packaging-declaration-search'], {
            state: { searchForm: this.searchFormState }
          });
        }
      });
  }

  buttonEconomico() {
    this.spinnerSrv.loadingShow();
    this.declaracionAdheridoControllerSrv
      .actualizarResumenEconomico(this.declaracionAdherido.id!)
      .subscribe({
        next: (res) => {
          this.declaracionAdherido.contriRapAnioCursoAbierto =
            res.contriRapAnioCursoAbierto;
          this.declaracionAdherido.contriRapAnioAnteriorAbierto =
            res.contriRapAnioAnteriorAbierto;
          this.declaracionAdherido.depoRapAnioCursoAbierto =
            res.depoRapAnioCursoAbierto;
          this.declaracionAdherido.depoRapAnioAnteriorAbierto =
            res.depoRapAnioAnteriorAbierto;

          this.declaracionAdherido.contriRapAnioCursoCerrado =
            res.contriRapAnioCursoCerrado;
          this.declaracionAdherido.contriRapAnioAnteriorCerrado =
            res.contriRapAnioAnteriorCerrado;
          this.declaracionAdherido.depoRapAnioCursoCerrado =
            res.depoRapAnioCursoCerrado;
          this.declaracionAdherido.depoRapAnioAnteriorCerrado =
            res.depoRapAnioAnteriorCerrado;

          this.declaracionAdherido.contriRapAnioCursoSoloUso =
            res.contriRapAnioCursoSoloUso;
          this.declaracionAdherido.contriRapAnioAnteriorSoloUso =
            res.contriRapAnioAnteriorSoloUso;

            this.declaracionAdherido.contriRapAnioCursoAbiertoSinGobernanza =
              res.contriRapAnioCursoAbiertoSinGobernanza;

          this.declaracionAdherido.reqActEconomica = res.reqActEconomica;

          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'El resumen económico se ha actualizado correctamente',
            'success'
          );
        },
        error: (error) => {
          if (error.error.detail) {
            this.snackBarSrv.showSnackBar(error.error.detail, 'error');
          } else {
            this.snackBarSrv.showSnackBar(
              'Ha ocurrido un error al actualizar el resumen económico',
              'error'
            );
          }
          this.spinnerSrv.loadingHide();
        },
      });
  }

  canAccessEditAllGlobal(): boolean {
    return (
      this.authService.can('dec_envases', 'update') &&
      this.declaracionAdherido?.estadoDeclaracion?.id == 0
    );
  }

  canAccessFinalizar() {

    this.requisitosFinalizarGestorEnvalora()
    return (
      ((this.canViewRol('AD-ADHERIDO') || this.canViewRol('AD-ADHERIDO'))
      || (this.esGestorEnvalora() && this.requisitosFinalizarGestorEnvalora()))
      && this.declaracionAdherido?.estadoDeclaracion?.id == 0
    );
  }

  canViewRol(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }


  buttonFinalizarDeclaracion() {

    // Estas validaciones pasar a hacerse en el back por un problema con la paginación.
    
    // if (!this.comprobarSumaEnvases() || !this.comprobarEnvaseMaterial()) {
    //   this.showDifentesPesosErrorDialog();
    //   return;
    // }

    // // Si falta la composición de materiales en los envases, bloquear la finalización y mostrar mensaje
    // if (this.comprobarFinalizarSinMaterialComposicion()) {
    //   this.confirmarFinalizacionSinMaterialComposicion();
    //   return;
    // }

    this.checkComprobacionEnvases();
  }

  confirmarFinalizacionConEnvasesCero() {
    swal.fire({
      text: 'Se ha detectado en la declaración de envases que existen categorías o centros de envasado en los que no se ha declarado ningún envase. Por favor, revise su declaración.',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Finalizar declaración',
      denyButtonText: 'Cancelar',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.confirmarFinalizacionConSectoresVacios();
      }
    });
  }

  confirmarFinalizacionConSectoresVacios() {
    //Obtener los centros de nuevo (para asegurarse de tener los sectores y % comercializacion actualizados)
    let filtro: DeclaracionCentroFilterDTO = {
      declaracionAdherido: {
        id: [this.declaracionAdherido?.id.toString()],
      },
    };
    this.spinnerSrv.loadingShow();
    this.declaracionCentroControllerSrv.findAll6(filtro).subscribe({
      next: (responses) => {
        this.spinnerSrv.loadingHide();
        let centrosDeclaracion = responses;
          // Comprobar que la suma de % de comercialización por centro no supere 100
          const centrosConPorcExcedido = (centrosDeclaracion || []).some((centro: DeclaracionCentroDTO) => {
            const totalPorc = (centro?.centroComunidad || []).reduce((acc: number, cc: any) => {
              const val = Number(cc?.porcCCAA);
              return acc + (isNaN(val) ? 0 : val);
            }, 0);
            return totalPorc > 100 + 0.0001;
          });

          if (centrosConPorcExcedido) {
            this.spinnerSrv.loadingHide();
            swal.fire({
              text: 'En algún centro de envasado no se ha indicado un % de comercialización de las CCAA destino de sus envases igual a 100%. Por favor, reajuste el porcentaje de comercialización.',
              icon: 'question',
              showConfirmButton: true,
              confirmButtonText: 'Aceptar',
              allowOutsideClick: false,
            }).then((result: any) => {
              //if (result.isConfirmed) {
              //  this.finalizarDeclaracion();
              //}
            });
            return;
        }

        // Comprueba si hay centros con todos los sectores o todos los centroComunidad vacíos
        //Se comprueban solo los centros que tengan envases
        const centrosConEnvases = this.centrosEnvases.filter((item:any) => item.numEnvases > 0).map(c => c.idCentro);
        let centrosConSectPorVacios = false;
        if(centrosConEnvases && centrosConEnvases.length > 0){
          centrosConSectPorVacios = centrosDeclaracion.some((centro: DeclaracionCentroDTO) => (centrosConEnvases.includes(centro?.id) && (!centro?.sectores || centro?.sectores?.length === 0 || !centro?.centroComunidad || centro?.centroComunidad?.length === 0)));
        }

        if(centrosConSectPorVacios){
          swal.fire({
            text: 'En algún centro de envasado no se han indicado los sectores de destino y/o el % de comercialización de las CCAA destino de sus envases y son de obligatorio cumplimiento. Por favor, informe dicha información antes de finalizar.',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            confirmButtonText: 'Finalizar declaración',
            denyButtonText: 'Cancelar',
            allowOutsideClick: false,
          }).then((result: any) => {
            //if (result.isConfirmed) {
            //  this.finalizarDeclaracion();
            //}
          });
        }else{
          this.finalizarDeclaracion();
        }
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar("Ha ocurrido un error al obtener los centros", "error");
      },
    });

  }

  checkComprobacionEnvases(): void {
    // Comprueba si la declaración no tiene envases
    this.spinnerSrv.loadingShow();
    this.declaracionAdheridoControllerSrv.comprobarEnvases(this.declaracionAdherido?.id, 'response')
      .subscribe({
        next: (response) => {
          this.spinnerSrv.loadingHide();
          if(response?.body?.noEnvasesCategoriasSDDR === true){
            this.showComprobarCentrosCategoriaSDDRSinEnvase()
            return;
          }
          else if (response.body?.noEnvasesCategoriasNoSDDR === true) {
            this.noEnvasesCategoriasNoSDDR = true
          } 
          this.showConfirmDialog();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  finalizarDeclaracion(): void {

      this.spinnerSrv.loadingShow();
      this.declaracionAdheridoControllerSrv
        .finalizarDeclaracion(this.declaracionAdherido?.id)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              'Se ha finalizado la declaración correctamente',
              'success'
            );

            //El estado 9 es baja de Envalora
            if (this.declaracionAdherido?.version.endsWith('D')
              && this.declaracionAdherido?.adherido?.estado?.id !== 9
            ) {
              this.duplicarDeclaracion()
            }

            this.router.navigate([
              '/attached-app/packaging-declaration-search'
            ]);


          },
          error: () => {
            this.spinnerSrv.loadingHide();
          },
        });
    
  }

    esGestorEnvalora(){
    return (this.canViewRol('AD-ENV-GEST') || this.canViewRol('AD-ENV-CONS'));
  }

  duplicarDeclaracion() {

    this.declaracionAdheridoControllerSrv
      .duplicarDeclaracion(this.declaracionAdherido?.id)
      .subscribe({
        next: (dto) => {
          this.declaracionDuplicada = dto;

          swal.fire({
            text: `Se ha generado una declaración estimativa para el año ${dto.anioDatos} utilizando los datos de la declaración definitiva del año anterior. ¿Desea confirmar estos datos como la estimación para el presente ejercicio?`,
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            denyButtonText: 'Modificar',
            allowOutsideClick: false,
          }).then((result: any) => {
            if (result.isConfirmed) {
              this.declaracionAdheridoControllerSrv.finalizarDeclaracion(this.declaracionDuplicada?.id)
                .subscribe(() => {
                  this.router.navigate([
                    '/attached-app/packaging-declaration-search'
              ]);
                });
            }
            else if (result.isDenied) {
              this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
                this.router.navigate([
                  '/attached-app/packaging-declaration-detail',
                  this.declaracionDuplicada?.id
                ]);
              });
            }



          });
        },
        error: (err) => {
          console.error('Error al duplicar la declaración:', err);
        }
      });


  }

  getMessageForBanner(){

    if(this.messagesForBanner[this.declaracionAdherido?.anioDatos]){
      return this.messagesForBanner[this.declaracionAdherido?.anioDatos];
    }if(this.declaracionAdherido?.anioDatos < 2025){
       return this.messagesForBanner[2025];
    }else{

      const años = Object.keys(this.messagesForBanner)
      .map(Number)
      .sort((a, b) => a - b);

      const ultimoMensaje = this.messagesForBanner[años[años.length - 1]];

      return ultimoMensaje
    }

  }


    obtenerFiltro(): DeclaracionEnvaseFilterDTO {

      // filtrado
      let filtro: DeclaracionEnvaseFilterDTO = {};

      let arrayIdsBusqueda : any = [];
        this.centrosDeclaracion.forEach(element => {
        arrayIdsBusqueda.push(String(element.id))
      });
      if (arrayIdsBusqueda.length > 0 ) {
        filtro.declaracionCentro = { id: arrayIdsBusqueda };
      }

      return filtro;
    }

    buscarDeclaracionesEnvase(){
      let filtro : any = this.obtenerFiltro();
   const sort = this.currentSort != '' ? this.currentSort : this.defaultSort;
    // paginación
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    let pag = {
      page: page,
      size: this.pageSize,
      sort: [sort],
    };

   this.declaracionEnvaseControllerService.findAll4(filtro, pag).subscribe({
      next: (response: PageDTODeclaracionEnvaseDTO) => {
        this.declaracionEnvase = response?.datos!;
        this.mostrarBotonFinalizar = this.comprobarEnvasesSDDR()
        if(this.comprobarTipoEnvase() && this.declaracionAdherido.version.endsWith('D')
        && this.declaracionAdherido.estadoDeclaracion.id === 0 && this.avisoBidones
        && this.canViewRol('AD-ADHERIDO') && this.declaracionAdherido.anioDatos === '2025'){
          this.showComprobarTipoEnvaseDialog();
        }
        this.avisoBidones = false;
            this.comprobarSumaEnvases()
            this.comprobarEnvaseMaterial()
      },
      error: (err: any) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Ha ocurrido un error al buscar los envases',
          'error'
        );
      },
    });
    }


  comprobarTipoEnvase(): boolean {

    let codigo_tipo_envase = 'E006';
    let codigo_tipo_envase1 = 'E005'
    let codigo_tipo_envase2 = 'E007'


    return this.declaracionEnvase.some(
      (element: { tipoEnvase: { codigoTipoEnvase: string } }) =>
        element.tipoEnvase?.codigoTipoEnvase === codigo_tipo_envase ||
        element.tipoEnvase?.codigoTipoEnvase === codigo_tipo_envase1 ||
        element.tipoEnvase?.codigoTipoEnvase === codigo_tipo_envase2
    );

  }

    showConfirmDialog(){

      swal.fire({
      text: '¿Está seguro de finalizar y dar por completada la declaración? No podrán agregarse más envases a esta declaración.',
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        // Verificar si no hay envases
        if(this.noEnvasesCategoriasNoSDDR === true){
            this.confirmarFinalizacionConEnvasesCero();
        }
        else {
            this.confirmarFinalizacionConSectoresVacios();
          }
      }
    });

    }

    showComprobarTipoEnvaseDialog(){
            swal.fire({
        html: `
          Si en la declaración estimativa de 2025 ha incluido alguno de los siguientes tipos de envases, revise sus datos. La clasificación de estos envases ha sido modificada:
          <br><br>
          · Bidón, barril, bombona boca estrecha (Tight-Head)<br>
          · Bidón ballesta, barril, bombona de boca ancha<br>
          · Jerricanes, garrafas
        `,
        icon: 'info',
        confirmButtonText: 'Aceptar',
        allowOutsideClick: false
      })
    //   .then((result) => {
    //     if (result.isConfirmed) {
    //     }
    //   });
    // } else {
    // }
    }

  requisitosFinalizarGestorEnvalora() {

     if(this.declaracionAdherido.campana === null){
      return false
    }

    const fechaActual = Date.now();
    const fechaFinalizacion = new Date(this.declaracionAdherido.campana.fechaFinalizacion).getTime();



    if (fechaFinalizacion < fechaActual
      && this.declaracionAdherido.adherido.estado.id === 9) {
      return true;
    }
    return false;
  }

comprobarEnvasesSDDR() {
  if (!this.centrosDeclaracion || !this.declaracionEnvase) return true;
    const idSDDR = [3, 4, 5, 6]
    //Se filtran los centros que tengan categoria de envase con id de SDDR.
    const declaracionCentroIdSDDR = [
      ...new Set(
        this.centrosDeclaracion
          .filter(d => d.categoriaEnvase && d.categoriaEnvase.id !== undefined && idSDDR.includes(d.categoriaEnvase.id))
          .map(d => d.id as number)
      )
    ];

    let filtrarDeclaracionEnvaseSDDR = [
      ...new Set(
      this.declaracionEnvase.filter((d: { categoriaEnvase: { id: undefined; }; declaracionCentro: { categoriaEnvase: { id: number; }; }; })  =>
        d.declaracionCentro.categoriaEnvase && d.declaracionCentro.categoriaEnvase.id !== undefined && idSDDR.includes(d.declaracionCentro.categoriaEnvase.id))
      .map((d: { declaracionCentro: { id: number; }; }) => d.declaracionCentro.id as number)
    )
    ]

    if(declaracionCentroIdSDDR.length !== filtrarDeclaracionEnvaseSDDR.length){
      this.mostrarBotonFinalizar = false
      return false;
    }

    return true;
  }

      showComprobarCentrosCategoriaSDDRSinEnvase(){
            swal.fire({
        text: 'Tiene centros con categoria SDDR sin envases declarados.',
        icon: 'error',
        denyButtonText: 'Aceptar',
        allowOutsideClick: false
      })
    //   .then((result) => {
    //     if (result.isConfirmed) {
    //     }
    //   });
    // } else {
    // }
    }

  comprobarSumaEnvases() {
    let comprobacion : boolean = true;
    //Comprobar que haya envases antes de iterar. Si no los hay se pasa la validación.
    if (!this.declaracionEnvase) {
      return comprobacion;
    }

    for (const envase of this.declaracionEnvase) {
       if (!comprobacion) {
        return comprobacion;
      }
      if (envase.declaracionCentro.categoriaEnvase.id === 3
        || envase.declaracionCentro.categoriaEnvase.id === 4) {
        //Es para SDDRCC, hay que cambiar el envase.unidadesTotales por envase.unidadesNuevas, usa unidadesTotales para forzar el error


              if (Math.abs(+envase.unidadesNuevas * +envase.pesoUnitario -  +envase.pesoTotal) > this.EPSILON
        && Math.abs(+envase.pesoTotal / +envase.unidadesNuevas - +envase.pesoUnitario) > this.EPSILON) {
          return comprobacion = false;
        }
        
      }
      else if (envase.declaracionCentro.categoriaEnvase.id === 5
        || envase.declaracionCentro.categoriaEnvase.id === 6
        || envase.declaracionCentro.categoriaEnvase.id === 1
        || envase.declaracionCentro.categoriaEnvase.id === 2) {
        //Es lo mismo que lo de arriba pero para SDDRCA y USO
        if (Math.abs(+envase.unidadesTotales * +envase.pesoUnitario -  +envase.pesoTotal) > this.EPSILON
        && Math.abs(+envase.pesoTotal / +envase.unidadesTotales - +envase.pesoUnitario) > this.EPSILON) {
          return comprobacion = false;
        }
      }
    }
    return comprobacion;
  }

    showDifentesPesosErrorDialog(){
            swal.fire({
        text: 'Los pesos declarados en los envases, no coincide con el total.',
        icon: 'error',
        denyButtonText: 'Aceptar',
        allowOutsideClick: false
      })
    //   .then((result) => {
    //     if (result.isConfirmed) {
    //     }
    //   });
    // } else {
    // }
    }

  comprobarEnvaseMaterial() {
    let comprobacion = true;
    if(!this.declaracionEnvase){
      return comprobacion;
    }
    let pesoUnitario;
    let pesoTotal;

    for (let declaracionEnvase of this.declaracionEnvase) {
      let sumaPesoUnitario = 0;
      let sumaPesoTotal = 0;
      pesoUnitario = declaracionEnvase.pesoUnitario
      pesoTotal = declaracionEnvase.pesoTotal
      for (let material of declaracionEnvase.envaseMaterial) {
        sumaPesoUnitario += (material.pesoUnitario);
        sumaPesoTotal += (material.pesoTotal);
      }
      if (comprobacion === false) {
        return comprobacion;
      }
      comprobacion = (Math.abs(sumaPesoUnitario - pesoUnitario) < this.EPSILON
        || Math.abs(sumaPesoTotal - pesoTotal) < this.EPSILON)
        ? true : false;
    }

    return comprobacion;

  }
  comprobarFinalizarSinMaterialComposicion() {
    // Comprobar por cada envase que exista al menos un "material de composición"
    // (en la estructura, un material de composición tiene `tipoElemento === null`).
    if (!this.declaracionEnvase || this.declaracionEnvase.length === 0) {
      return false;
    }

    for (const envase of this.declaracionEnvase) {
      const materials = Array.isArray(envase?.envaseMaterial)
        ? envase.envaseMaterial
        : envase?.envaseMaterial
        ? [envase.envaseMaterial]
        : [];

      // Si no hay materiales en el envase, considerar que falta composición
      if (!materials || materials.length === 0) {
        return true;
      }

      // Si ninguno de los materiales es un "material de composición" (tipoElemento === null)
      const hasComposicion = materials.some((m: any) => m?.tipoElemento === null);
      if (!hasComposicion) {
        return true;
      }
    }

    return false;

  }
  confirmarFinalizacionSinMaterialComposicion() {
    // Mensaje informativo y bloqueante: no permite finalizar la declaración
    swal.fire({
      text: 'Se ha detectado en la declaración de envases que existen envases en los que no se ha declarado ningún material de composición. Por favor, revise su declaración.',
      icon: 'error',
      showDenyButton: false,
      showCancelButton: false,
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false,
    });
  }
}
